import { render } from "./DangerModal.vue?vue&type=template&id=b7922b52"
import script from "./DangerModal.vue?vue&type=script&lang=js"
export * from "./DangerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__